import axios from "axios";
import store from './../index'
import { getCurrentDateTimeString } from '../../utils/dateTime';
export default {
  state: {
    analyzes: null,
  },
  getters: {
    ANALYZES: state => {
      return state.analyzes;
    },
  },
  mutations: {
    SET_ANALYZES: (state, payload) => {
      state.analyzes = payload;
    },
  },
  actions: {
    ANALYZES: (commit, payload) => {
      return new Promise((resolve, reject) => {
        axios
          .post(`/Report/GetPriceAnalysisAsync`, payload)
          .then(({
            data,
            status
          }) => {
            if (status === 200) {
              store.commit('SET_ANALYZES', data);
              resolve(data);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    DOWNLOAD_EXCEL_FILE: (commit, payload) => {
      return new Promise((resolve, reject) => {
        axios
          .post(`/Report/DownloadExcelFileAsync`, payload, {
            responseType: 'blob'
          })
          .then(({
            data,
            status
          }) => {
            if (status === 200) {
              let url = window.URL.createObjectURL(new Blob([data]));
              let link = document.createElement('a');
              link.href = url;

              const filename = `Ценевой_анализ_${getCurrentDateTimeString()}.xlsx`;
              link.setAttribute('download', filename);
              document.body.appendChild(link);
              link.click();
              
              resolve(true);
            }
            if (status === 204) {
              resolve(false);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    FILIALS_PRICE_ACTUALITY: async () => {
      try {
        const { data } = await axios.get(`/Report/GetFilialsPriceActualityAsync`);
        return data;
      } catch (error) {
        const Snackbar = {
          text: error.response?.data?.message
            || error.response?.data?.title
            || 'Не удалось загрузить отчёт по актуальности цен',
          timeout: 7500,
          color: 'error',
          linkText: '',
          show: true,
        };
        store.commit('SET_SNACKBAR', Snackbar);
        throw error;
      }
    },
    RATING_REPORT_FILTER_OPTIONS: async () => {
      try {
        const { data } = await axios.get(`/RatingReport/GetFilterOptionsAsync`);
        return data;
      } catch (error) {
        // Текст ошибки уже показал интерцептор axios (403 «У вас нет доступа…» при истёкшем комплекте, 400 с error,
        // сеть) — свой общий снекбар его перекрывал, и причина терялась (случай karyagin 27.10.2026)
        throw error;
      }
    },
    DOWNLOAD_RATING_REPORT: (commit, payload) => {
      return new Promise((resolve, reject) => {
        axios
          .post(`/RatingReport/DownloadAsync`, payload, {
            responseType: 'blob'
          })
          .then(({
            data,
            status
          }) => {
            if (status === 200) {
              let url = window.URL.createObjectURL(new Blob([data]));
              let link = document.createElement('a');
              link.href = url;

              const filename = `Отчет_рейтинг_${getCurrentDateTimeString()}.xlsx`;
              link.setAttribute('download', filename);
              document.body.appendChild(link);
              link.click();
              link.remove();
              window.URL.revokeObjectURL(url);

              resolve(true);
            }
            if (status === 204) {
              resolve(false);
            }
          })
          .catch(error => {
            reject(error);
          });
      })
    },
    SALES_TREND_REPORT_FILTER_OPTIONS: async () => {
      try {
        const { data } = await axios.get(`/SalesTrendReport/GetFilterOptionsAsync`);
        return data;
      } catch (error) {
        // Текст ошибки уже показал интерцептор axios (403 «У вас нет доступа…» при истёкшем комплекте, 400 с error,
        // сеть) — свой общий снекбар его перекрывал, и причина терялась (случай karyagin 27.10.2026)
        throw error;
      }
    },
    DOWNLOAD_SALES_TREND_REPORT: async (commit, payload) => {
      try {
        const { data, status } = await axios.post(`/SalesTrendReport/DownloadAsync`, payload, {
          responseType: 'blob'
        });

        if (status === 204) {
          return false;
        }

        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `Тренд_продаж_дистрибьюторов_${getCurrentDateTimeString()}.xlsx`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);

        return true;
      } catch (error) {
        // Ответ запрошен как blob, поэтому текст ошибки валидации (400, { error }) читаем из него
        let text = 'Не удалось сформировать отчёт';
        try {
          const body = error.response?.data;
          if (body instanceof Blob) {
            text = JSON.parse(await body.text()).error || text;
          } else if (body?.error) {
            text = body.error;
          }
        } catch (parseError) {
          window.console.log(parseError);
        }
        store.commit('SET_SNACKBAR', {
          text,
          timeout: 7500,
          color: 'error',
          linkText: '',
          show: true,
        });
        throw error;
      }
    },
    SALES_PER_DAY_REPORT_FILTER_OPTIONS: async () => {
      try {
        const { data } = await axios.get(`/SalesPerDayReport/GetFilterOptionsAsync`);
        return data;
      } catch (error) {
        // текст ошибки уже показал интерцептор axios — см. RATING_REPORT_FILTER_OPTIONS
        throw error;
      }
    },
    // Файл отдаётся всегда, даже если за период нет продаж (как в старом ФЦ)
    DOWNLOAD_SALES_PER_DAY_REPORT: async (commit, payload) => {
      try {
        const { data } = await axios.post(`/SalesPerDayReport/DownloadAsync`, payload, {
          responseType: 'blob'
        });

        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'PerDayReport.xlsx');
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);

        return true;
      } catch (error) {
        // Ответ запрошен как blob, поэтому текст ошибки валидации (400, { error }) читаем из него
        let text = 'Не удалось сформировать отчёт';
        try {
          const body = error.response?.data;
          if (body instanceof Blob) {
            text = JSON.parse(await body.text()).error || text;
          } else if (body?.error) {
            text = body.error;
          }
        } catch (parseError) {
          window.console.log(parseError);
        }
        store.commit('SET_SNACKBAR', {
          text,
          timeout: 7500,
          color: 'error',
          linkText: '',
          show: true,
        });
        throw error;
      }
    },
    MISSING_GOODS_REPORT_FILTER_OPTIONS: async () => {
      try {
        const { data } = await axios.get(`/MissingGoodsReport/GetFilterOptionsAsync`);
        return data;
      } catch (error) {
        // текст ошибки уже показал интерцептор axios — см. RATING_REPORT_FILTER_OPTIONS
        throw error;
      }
    },
    // Файл отдаётся всегда, даже если недостающих позиций нет (как в старом ФЦ)
    DOWNLOAD_MISSING_GOODS_REPORT: async (commit, payload) => {
      try {
        const { data } = await axios.post(`/MissingGoodsReport/DownloadAsync`, payload, {
          responseType: 'blob'
        });

        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'Недостающие позиции.xlsx');
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);

        return true;
      } catch (error) {
        // Ответ запрошен как blob, поэтому текст ошибки валидации (400, { error }) читаем из него
        let text = 'Не удалось сформировать отчёт';
        try {
          const body = error.response?.data;
          if (body instanceof Blob) {
            text = JSON.parse(await body.text()).error || text;
          } else if (body?.error) {
            text = body.error;
          }
        } catch (parseError) {
          window.console.log(parseError);
        }
        store.commit('SET_SNACKBAR', {
          text,
          timeout: 7500,
          color: 'error',
          linkText: '',
          show: true,
        });
        throw error;
      }
    },
    TOP_PRODUCTS_SOLD: async () => {
      try {
        const { data } = await axios.get(`/TopProductsSold/GetAllAsync`);
        return data;
      } catch (error) {
        const Snackbar = {
          text: error.response?.data?.message
            || error.response?.data?.title
            || 'Не удалось загрузить топ продаваемых товаров',
          timeout: 7500,
          color: 'error',
          linkText: '',
          show: true,
        };
        store.commit('SET_SNACKBAR', Snackbar);
        throw error;
      }
    },
    DOWNLOAD_AVERAGE_PRICES_REPORT: (commit, payload) => {
      return new Promise((resolve, reject) => {
        axios
          .post(`/Report/DownloadAveragePricesPeport`, payload, {
            responseType: 'blob'
          })
          .then(({
            data,
            status
          }) => {
            if (status === 200) {
              let url = window.URL.createObjectURL(new Blob([data]));
              let link = document.createElement('a');
              link.href = url;

              const filename = `Доли_продаж_${getCurrentDateTimeString()}.xlsx`;
              link.setAttribute('download', filename);
              document.body.appendChild(link);
              link.click();
              
              resolve(true);
            }
            if (status === 204) {
              resolve(false);
            }
          })
          .catch(error => {
            reject(error);
          });
      })
    }
  },
};